import { render, staticRenderFns } from "./departamento.vue?vue&type=template&id=0b5d178f&"
import script from "./departamento.vue?vue&type=script&lang=js&"
export * from "./departamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports